import { useQuery } from "@tanstack/react-query"

import { getLocalAiLeads } from "@/api/admin-api"

/** The cache key every local-AI-lead write invalidates. */
export const LOCAL_AI_LEADS_QUERY_KEY = ["admin", "localAiLeads"] as const

/**
 * The local AI lead roster.
 *
 * Shared by the management card and by Fair use → Users & licences, which
 * joins it onto the overview rows to badge who is a lead when the overview
 * itself could not read the roster. React Query dedupes the two callers by
 * key, so the tab renders both with one request.
 */
export function useLocalAiLeadsQuery() {
  return useQuery({
    queryKey: LOCAL_AI_LEADS_QUERY_KEY,
    queryFn: getLocalAiLeads,
  })
}
